import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useDispatch, useSelector } from 'react-redux';
import dashboardData from './data/dashboardData.json';
import DefaultLayout from './routes/DefaultLayout';
import BuyerLayout from './routes/BuyerLayout';
import MakersharksLayout from './routes/MakersharksLayout';
import SupplierLayout from './routes/SupplierLayout';
import { initializeTokens } from './api/tokenService';
import { connectWebSocket } from './api/chatService';

function App() {
  const dispatch = useDispatch();

  const userData = useSelector((state) => state?.authReducer?.userData);
  const isLoggedIn = useSelector((state) => state?.authReducer?.isLoggedIn);
  const isVerified = useSelector((state) => state?.authReducer?.isVerified);
  const authState = useSelector((state) => state?.authReducer);

  initializeTokens(authState);
  const role = userData?.role;

  useEffect(() => {
    if (isLoggedIn && isVerified && userData?.user_id && userData?.role) {
      console.log('Connecting to WebSocket...');
      console.log('User ID:', userData?.user_type_id);
      connectWebSocket((client) => {
        const subscription = client.subscribe(
          `/topic/notifications/${userData?.user_type_id}`,
          (notification) => {
            const data = JSON.parse(notification.body);
            console.log('Notification received:', data);
            if (data.type === 'NEW_MESSAGE') {
              // fetchChats();
            }
          },
        );
      });
    }
  }, [isLoggedIn, isVerified, userData]);

  // IF USER IS LOGGED IN AND AUTHTOKEN (authKeyExpiredAt) IS Expired, THEN LOGOUT
  // useEffect(() => {
  //   if (isLoggedIn && isVerified) {
  //     const authKeyExpiredAt = localStorage.getItem('authKeyExpiredAt');
  //     if (authKeyExpiredAt < new Date().getTime()) {
  //       dispatch(logoutUserAction());
  //       // remove all local storage
  //       localStorage.clear();
  //       // refresh the page
  //       window.location.reload();
  //     }
  //   }
  // });

  const layoutMapping = {
    makersharks: <MakersharksLayout />,
    supplier: <SupplierLayout />,
    buyer: <BuyerLayout />,
  };

  // Helper function to determine which layout to show
  const getActiveLayout = () => {
    if (!isLoggedIn) {
      return <DefaultLayout />;
    }

    if (!isVerified) {
      return <DefaultLayout />; // This will handle verification route
    }

    if (!role) {
      return <DefaultLayout />;
    }

    // If user is logged in, verified, and has a role, show their layout
    return layoutMapping[role] || <DefaultLayout />;
  };

  return (
    <BrowserRouter>
      <GoogleOAuthProvider clientId="1088179430567-nalb7jmerthk71voo15b8lrpvotd4pno.apps.googleusercontent.com">
        {getActiveLayout()}
      </GoogleOAuthProvider>
    </BrowserRouter>
  );
}

export default App;
